var SIZE = {
  INSET_SPACING: 2,
  THUMB: 16,
  TRACK_WIDTH: 40,
  TRACK_HEIGHT: 20
};
export default SIZE;